import { Button, Typography } from '@material-ui/core'
import React from 'react'
import { useDropzone } from 'react-dropzone'
import { makeStyles } from '@material-ui/core/styles'
import { useSelector, useDispatch } from 'react-redux'
import { setAttachment } from 'redux/actions/'
import { useSnackbar } from 'notistack'

const useStyles = makeStyles(theme => ({
  button: {
    zIndex: 2,
    whiteSpace: 'nowrap',
    minWidth: '6rem',
    marginRight: '5px'
  },
  text: {
    whiteSpace: 'nowrap',
    margin: 'auto 0',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
}))

export default function Dropzone({ children }) {
  const classes = useStyles()
  const { enqueueSnackbar } = useSnackbar()
  const dispatch = useDispatch()
  const fileName = useSelector(
    state => state.signup.attachment?.importedFile?.name
  )
  const handleFile = file => {
    let reader = new FileReader()
    reader.onload = event => {
      dispatch(
        setAttachment({
          importedFile: {
            name: file.name,
            path: file.path,
            type: file.type,
            size: file.size
          },
          preview: event.target.result
        })
      )
    }
    reader.readAsDataURL(file)
  }
  const { getInputProps, open } = useDropzone({
    // Disable click and keydown behavior
    noClick: true,
    noKeyboard: true,
    multiple: false,
    //  ["image/jpg","image/png","image/jpeg","image/gif","application/pdf"]
    // accept: 'application/pdf, image/jpeg, image/jpg, image/png, image/gif',
    accept: '*',
    onDropAccepted: acceptedFile => {
      // this logic is wrong since jfif is same as JPEG
      // but this is how it's handled in the backend it doesn't accepts jfif
      if (acceptedFile[0].name.split('.')[1] !== 'jfif')
        return handleFile(acceptedFile[0])

      enqueueSnackbar('jfif files are not allowed', {
        variant: 'error'
      })
    },
    onDropRejected: e =>
      enqueueSnackbar(e[0].errors[0].message, {
        variant: 'error'
      })
  })

  return (
    <div style={{ display: 'flex' }}>
      <input {...getInputProps()} />
      <Button
        size="small"
        className={classes.button}
        variant="contained"
        color="primary"
        onClick={open}>
        {children}
      </Button>
      <Typography className={classes.text} variant="caption">
        {fileName ? fileName : 'no file selected'}
      </Typography>
    </div>
  )
}
